// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DvN\\+MQVW-PCOAol0jOcfHA\\=\\={background-color:var(--xds-color-support-brand-06) !important;border-color:var(--xds-color-support-brand-06) !important;color:var(--xds-color-content-light) !important;text-transform:capitalize}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardCustomTag/components/TagAlcohol/TagAlcohol.module.scss"],"names":[],"mappings":"AAAA,6BACI,6DAAA,CACA,yDAAA,CACA,+CAAA,CACA,yBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TagAlcohol": "DvN+MQVW-PCOAol0jOcfHA=="
};
export default ___CSS_LOADER_EXPORT___;
